import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Service } from "src/app/core/jsonapi/service";
import { Dataset } from "../_types/dataset";

@Injectable({
    providedIn: 'root',
})

export class DatasetsService extends Service<Dataset> {
  public override type = 'datasets';
  public override url = 'reporting/datasets';

  snapshot(datasetId: string): Observable<any> {
    let url = this.getAPIUrl() + "/" + datasetId + "/snapshot";
    return this.http.post<any>(url, {});
  }
}
